import { ExperimentType, ExtensionDetailsType, FeatureConfig } from "../Types";

export const CREATE_KEY = "create";
export const CLONE_KEY = "clone";
export const ARCHIVE_KEY = "_ARCHIVED_";
export const EXTENSION_UPDATE_KEY = "EXTENSION CONFIG UPDATE";
export const UNARCHIVE_KEY = "UNARCHIVE";
export const EXTENSIONS_PATH_KEY = "extensions";
export const EXPERIMENT_PATH_KEY = "experiment";
export const VARIANT_DETAIL_CONTROL_KEY = "control";
export const VARIANT_DETAIL_TREATMENT_KEY = "treatment";
export const PIPELINE_CONFIG_PR_KEY = "addPipelineIds";
export const MULTI_CONFIG_KEY = "multiConfig";

export const REPO_URL =
  "https://dev.azure.com/msazure/One/_git/AzureUX-Experimentation";
export const REPO_ID = "9ce231fd-8cb1-421e-bb61-7bbdd9d382bb";

export const EA_TO_EV2_EXTENSION_MAPPINGS_KEY = "EAToEV2ExtensionMappings";
export const EXTENSION_KEY_LOCAL_STORAGE = "extensionName";
export const EXP_STUDIO_REPLACE_KEY = "{experimentpath}";
export const EXP_STUDIO_PATH = `https://exp.microsoft.com/extension/azure-portal-experiments/${EXP_STUDIO_REPLACE_KEY}?workspaceId=ee9fd4ce-6bba-4471-a3ce-a690e7e75039`;
export enum LOOKBACK_CONSTS {
  ALL = "all",
}

export const LONG_RUNNING_WARNING_THRESHOLD_DAYS = 7;
export const LONG_RUNNING_ERROR_THRESHOLD_DAYS = 30;
export const MAX_TRAFFIC_FILTER_COUNT = 128;
export const LEGACY_RUN_AGE_DAYS = 90;

export const EA_TO_EV2EXPERIMENT_MAPPING: Record<string, string> = {
  HubsExtension: "HubsAndShell",
  Microsoft_Azure_GTM: "Azure_BMX",
  Microsoft_Azure_Billing: "Azure_BMX",
  Microsoft_Azure_Storage: "Storage",
};

export const AcceptedFeatures: Record<string, FeatureConfig> = {
  /**
   * Feature to hide the top bar in the experiments table view.
   * true: hide the top bar
   * false: show the top bar
   */
  hideTopBar: {
    key: "hideTopBar",
    type: "boolean",
  },
};

export const AppName = "Azure Portal Experiments Control Hub";

export const DEFAULT_EXPERIMENT: ExperimentType = {
  analysisTags: [],
  extensionFilters: [],
  featureDescription: "",
  featureKey: "",
  featureName: "",
  tenantFilters: undefined,
  extensionVersionFilters: undefined,
  environmentFilters: undefined,
  __filename: "",
  __fullpath: "",
  __extension: "",
  __rootExtension: "",
};

export const DEFAULT_EXTENSION_CONFIG: ExtensionDetailsType = {
  displayName: "",
  secretId: "",
  assignmentUnit: "muid",
  environment: "Prod",
  serviceIdentifier: "",
  serviceGroup: "",
  tenantId: "",
  subscriptionKey: "",
  applicationId: "",
};
